import { PublicHeader } from '@roselabs-io/saas-shell'
import type { PublicNavItem } from '@roselabs-io/saas-shell'

const navItems: PublicNavItem[] = [
  { label: 'Features', href: '#features', isSection: true },
  { label: 'How It Works', href: '#how-it-works', isSection: true },
  { label: 'Pricing', href: '#pricing', isSection: true },
  { label: 'FAQ', href: '#faq', isSection: true },
  { label: 'Docs', href: '/docs' },
]

export function Header() {
  return (
    <PublicHeader
      logo={<img src="/falcon-logo.png" alt="Falcon" className="h-16 w-auto" />}
      navItems={navItems}
      position="fixed"
      variant="transparent"
      shadowOnScroll="lg"
      showProgress={true}
    />
  )
}
